module.exports = __webpack_public_path__ + "static/media/6.a9ba5abf.svg";